/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const billingEntityDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	country: z.string(),
})

export type BillingEntityDataSchema = z.infer<typeof billingEntityDataSchema>
